// removed by extract-text-webpack-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","blue":"#0076c0","hikeColor":"#58924D","runColor":"#0076C0","fitnessColor":"#375A92","rideColor":"#C53426","walkColor":"#885291","container":"container-2NwRa","price":"price-2JikN","frequency":"frequency-cBbae","active":"active-OtYKY","icon":"icon-3t-EL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_productItem.css
// module id = 1247
// module chunks = 1